import { Provider } from 'react-redux';
import { store } from './store';
import { AppProvider } from './contexts/AppContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { RouterProvider } from 'react-router-dom';
import { router } from './utils/routes';

export default function App() {
  return (
    <Provider store={store}>
      <LanguageProvider>
        <AppProvider>
          <RouterProvider router={router} />
        </AppProvider>
      </LanguageProvider>
    </Provider>
  );
}

